import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Store from 'store';
import * as Actions from '../actions';
import * as Selectors from '../selectors';
import * as Types from '../types';

interface IChildren {
  entities: Types.IEntity.Document[];
  isFetched: boolean;
  isLoaded: boolean;
}

interface IProps {
  onSuccess?: () => void;
  onError?: () => void;
  onFinally?: () => void;
}

const useList = ({ onSuccess = () => {}, onError = () => {}, onFinally = () => {} }: IProps = {}): IChildren => {
  const dispatch = useDispatch();
  const entities = useSelector<Store.Types.IState, Types.IEntity.Document[]>(state => Selectors.getList(state));
  const isFetched = useSelector<Store.Types.IState, boolean>(state => Selectors.getListIsFetched(state));
  const isLoaded = useSelector<Store.Types.IState, boolean>(state => Selectors.getListIsLoaded(state));

  useEffect(() => {
    dispatch(
      Actions.List.request({
        callback: {
          onSuccess,
          onError,
          onFinally
        }
      })
    );
  }, []);

  return {
    entities,
    isFetched,
    isLoaded
  };
};

export default useList;
